import { useAsyncExecutor, useAsyncExecutor2 } from "async-executor-hook";
import { differenceInMinutes, format } from "date-fns";
import { Paginator } from "primereact/paginator";
import { parse, stringify } from "query-string";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  from,
  interval,
  map,
  mapTo,
  startWith,
  Subject,
  switchMap,
  takeUntil,
  zip,
} from "rxjs";
import { Authorization } from "../../../common/AuthorizationCpt";
import { HTTP_METHODS } from "../../../utils/constants";
import { networkBackendRequest } from "../../../utils/networkUtils";
import ConfirmationModal from "../../ConfirmationModal/ConfirmationModal";
import { DeleteButton, EditButton } from "../../IconButtons";
import { InvoicesContainer, TableHeader } from "../../Invoices/InvoicesStyles";
import { POLLING_INTERVAL } from "../../Payment/common";
import PaymentLoader from "../../PaymentLoader/PaymentLoader";
import { Container } from "../../PaymentLoader/PaymentLoaderStyles";
import StandaloneMessage from "../../StandaloneMessage/StandaloneMessage";
import { Container1 } from "../../UsersManagement/UsersManagementStyles";
import {
  DivColumStatus,
  DivFlexColum,
  DivImgLoading,
  DivMarginLeft,
  PlateAmount,
  PlateBar,
  PlateSection,
  VctTicketRow,
} from "../../VctTicket/VctTicketStyles";
import VctTicketEditionSidebar from "../../VctTicketEditionSidebar/VctTicketEditionSidebar";
import VctTicketSidebarTraking from "./VctTicketSidebarTraking";
import LoadingSpinner from "../../../images/loading_gray.gif";
import Modal from "../../Modal/Modal";
import { Button } from "../../UsersManagementAdmin/UsersManagementAdminStyles";
import { ConfirmationModalThird } from "../../ConfirmationModal/ConfirmationModalThird";
import StatusTooltip from "../../StatusTooltip/StatusTooltip";
import { getErrorValueResponse } from "../../../common/error/Error";
import { USER_ROUTES } from "../../../utils/routeConstants";
import {
  AppointmentConvert,
  CustomDispacher,
  CustomsDispatcher,
  GetAppoimentParams,
  IdeleteAppointmentExecutor,
  ITurnTrackingParams,
  ITurnTrackingParams$,
  ITurnTrackingTableDeleteButton,
  ITurnTrackingTableEditButtonProps,
  ParamsLoadSchedule,
  Timeslot,
  TimesLots,
  VehicleCategory,
} from "../TurnTracking.interface";
import { Appointment, TurnTracking } from "../Tracking.interfaces";

const ITEMS_PER_PAGE = 8;
const TITLES = {
  agent: "AGENTE DE ADUANA",
  dispatcher: "ID/DESPACHADOR",
  date: "HORA DE RETIRO",
  plates: "PLACAS",
  segment: "ESTADO DE CITAS",
  dockNum: "DIQUE",
  turnColumn: "ESTADO DE TURNO",
  status: "ESTADO",
  actions: "ACCIONES",
  numTurn: "# TURNO",
};

const convertResponse = (resp: TurnTracking) => {
  const tickets = resp.appointments.map((detail: Appointment) => {
    const showEditAppointmet = detail.actions.includes("edit");
    const showDeleteAppointmet = detail.actions.includes("delete");
    const dateNow = new Date();
    const turnStatusEnabled =
      detail.turn_status.option === "calling" ||
      detail.turn_status.option === "waiting";
    const diffInMinutes = turnStatusEnabled
      ? differenceInMinutes(
          new Date(),
          new Date(detail.dock_call_time ? detail.dock_call_time : dateNow)
        )
      : null;
    const statusTurn = turnStatusEnabled && detail.dock_call_time;
    const invertDiffInMinutes = diffInMinutes * -1;
    return {
      ...detail,
      id: detail.appointment_id,
      appointmentNum: detail.appointment_num,
      volantes: detail.volantes,
      groupsNum: detail.groups_num_sum,
      parcelsWeight: detail.parcels_weight_sum,
      dispatcherId: detail.customs_dispatcher_json["external_id"],
      dispatcherDocumentNumber:
        detail.customs_dispatcher_json["document_number"],
      dispatcherName: detail.customs_dispatcher_json["full_name"],
      appointmentStatus: detail.turn_status,
      segmentCategory: detail.segment_category,
      vehicles: detail.vehicles,
      timeslot: detail.timeslot,
      vctId: detail.vct_id,
      dockNum: detail.dock_num,
      withdrawalDate: detail.withdrawal_date,
      agentName: detail.agent_name,
      turnNum: detail.turn_num,
      objectStatus: detail.object_status,
      plates: detail.vehicles.map((vehicle) => vehicle.plate),
      showEditAppointmet,
      showDeleteAppointmet,
      withdrawalType: detail.withdrawal_type,
      actions: detail.actions,
      updated_at: detail.updated_at,
      dateNow,
      diffInMinutes: invertDiffInMinutes,
      redCountDownMinutes: detail?.red_countdown_minutes
        ? detail?.red_countdown_minutes
        : 5,
      statusTurn,
      statusQuote: detail.object_status,
    };
  });
  return {
    tickets,
    num_pages: resp.num_pages,
    page_size: resp.page_size,
    count: resp.count,
  };
};

export const TurnTrackingTable = (props: ITurnTrackingParams$) => {
  const { params$ } = props;
  const destroy$Ref = useRef(new Subject());
  const destroy$: any = destroy$Ref.current;
  useEffect(() => {
    return () => {
      destroy$.next();
      destroy$.complete();
    };
  }, [destroy$]);

  const [dateUrlTracking, setDateUrlTracking] = useState(new Date());
  const loadInvoices: any = useAsyncExecutor2(
    (params) => {
      const destroy$ = destroy$Ref.current;
      return interval(POLLING_INTERVAL).pipe(
        takeUntil(destroy$),
        startWith(params),
        mapTo(params),
        switchMap((params) => {
          return interval(POLLING_INTERVAL).pipe(
            takeUntil(destroy$),
            startWith(params),
            mapTo(params),
            switchMap((params: any) => {
              setDateUrlTracking(params.withdrawal_from_date);
              const request = networkBackendRequest(
                "/appointments/",
                HTTP_METHODS.GET,
                params,
                undefined,
                undefined
              )
                .then((resp) => resp.json())
                .then(convertResponse);
              return from(request);
            })
          );
        })
      );
    },
    {
      params$: params$.pipe(
        takeUntil(destroy$Ref.current),
        map((params: ITurnTrackingParams) => ({
          ...params,
          withdrawal_from_date: format(
            params.withdrawal_from_date,
            "yyyy-MM-dd"
          ),
          withdrawal_to_date: format(params.withdrawal_to_date, "yyyy-MM-dd"),
          order: "descending",
          page: params.page ?? 1,
          page_size: ITEMS_PER_PAGE,
        }))
      ),
    }
  );

  const history = useHistory();
  const gridTemplateColumns = "25rem 1fr 1fr 1.5fr 1.5fr 1fr 1fr 14rem";

  const firstPlateFunctionOne = (appointment: AppointmentConvert) => {
    const vehiclePlate = appointment.vehicles.map((vehicle) => vehicle.plate);
    const validateCita = vehiclePlate.length === 0 ? "-" : vehiclePlate[0];

    return validateCita;
  };

  const additionalPlatesFunctionOne = (appointment: AppointmentConvert) => {
    const vehiclePlateadditional = appointment.vehicles.map(
      (vehicle) => vehicle.plate
    );
    const firstPlateAdditional =
      vehiclePlateadditional.length === 0 ? "-" : vehiclePlateadditional[0];

    const additionalPlates = vehiclePlateadditional
      .filter((plate) => {
        return plate !== firstPlateAdditional;
      })
      .map((plate) => {
        return {
          category: "neutral",
          label: plate,
        };
      });

    return additionalPlates;
  };

  const [showSidebar, updateShowSidebar] = useState<boolean>(false);

  const toggleSidebar = () => {
    updateShowSidebar(!showSidebar);
  };
  const [dataAppointment, setDataAppointment] = useState<AppointmentConvert>();

  const [isLoadingEdit, setIsLoadingEdit] = useState(false);
  const [nameDeletedSuccess, setNameDeletedSuccess] = useState("");
  const [showModalDeleteAppointment, setShowModalDeleteAppointment] =
    useState<boolean>(false);
  const [countNextPage, setCountNextPage] = useState(0);
  return (
    <>
      {showModalDeleteAppointment && (
        <ConfirmationModal
          message={`La cita con el despachador ${
            nameDeletedSuccess && nameDeletedSuccess
          } ha sido eliminado exitosamente`}
          onAccept={() => {
            setShowModalDeleteAppointment(false);
            const parsedParams = { ...parse(window.location.search), page: 1 };
            const stringifiedParams = stringify(parsedParams);
            const pathname = history.location.pathname;
            if (countNextPage > 0) {
              history.push(`${pathname}?${stringifiedParams}`);
            } else {
              history.push(USER_ROUTES.CREATE_QUOTES.path);
            }
          }}
          title={`Cita eliminado exitosamente`}
          toggleModal={() => {
            setShowModalDeleteAppointment(false);
            const parsedParams = { ...parse(window.location.search), page: 1 };
            const stringifiedParams = stringify(parsedParams);
            const pathname = history.location.pathname;
            if (countNextPage > 0) {
              history.push(`${pathname}?${stringifiedParams}`);
            } else {
              history.push(USER_ROUTES.CREATE_QUOTES.path);
            }
          }}
        />
      )}

      <Authorization actions={["appointment.get_appointments"]}>
        <InvoicesContainer gridTemplateColumns={gridTemplateColumns}>
          {loadInvoices.status === "PROCESSING" && (
            <>
              <PaymentLoader numItems={ITEMS_PER_PAGE} />
            </>
          )}
          {loadInvoices.status === "SUCCESS" && (
            <>
              {loadInvoices.data.tickets.length === 0 && (
                <StandaloneMessage>No se encontraron citas.</StandaloneMessage>
              )}
              {loadInvoices.data.tickets.length > 0 && (
                <>
                  <TableHeader className="item-container">
                    <div
                      className="left-aligned-header"
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginLeft: "2rem",
                      }}
                    >
                      {TITLES.dispatcher}
                    </div>
                    <div>{TITLES.date}</div>
                    <div>{TITLES.plates}</div>
                    <div>{TITLES.segment}</div>
                    <div>{TITLES.turnColumn}</div>
                    <div>{TITLES.numTurn}</div>
                    <div>{TITLES.dockNum}</div>
                    <div>{TITLES.actions}</div>
                  </TableHeader>
                  {loadInvoices.data.tickets.map(
                    (invoice: AppointmentConvert) => {
                      const appointment = invoice;
                      return (
                        <VctTicketRow
                          onClick={() => {
                            toggleSidebar();
                            setDataAppointment(invoice);
                          }}
                          className="item-container"
                          key={invoice.id}
                        >
                          <div className="attribute dispatcher-info">
                            <div className="titles">{TITLES.dispatcher}</div>
                            <div className="dispatcher-info">
                              <p className="dispatcher-id">
                                {appointment.dispatcherDocumentNumber}
                              </p>
                              <p>{appointment.dispatcherName}</p>
                              <p className="volantes-num">
                                {`${appointment.volantes.length} volante${
                                  appointment.volantes.length === 1 ? "" : "s"
                                }`}
                              </p>
                            </div>
                          </div>
                          <div className="attribute">
                            <div className="titles">{TITLES.date}</div>
                            <div className="aux-div">
                              <div>
                                {formatTime(appointment.timeslot.start)} a{" "}
                                {formatTime(appointment.timeslot.end)}
                              </div>
                            </div>
                          </div>
                          <div className="attribute">
                            <div className="titles">{TITLES.plates}</div>
                            <PlateSection>
                              <PlateBar>
                                <span>
                                  {firstPlateFunctionOne(
                                    appointment
                                  ).toUpperCase()}
                                </span>
                                {additionalPlatesFunctionOne(appointment)
                                  .length > 0 && (
                                  <PlateAmount status={"neutral"}>
                                    <span>
                                      {"+" +
                                        additionalPlatesFunctionOne(appointment)
                                          .length}
                                    </span>
                                  </PlateAmount>
                                )}
                              </PlateBar>
                              {appointment.plates.length > 1 ? (
                                <StatusTooltip
                                  className="tooltip"
                                  statusList={appointment.plates
                                    .filter(
                                      (plate) => plate !== appointment.plates[0]
                                    )
                                    .map((plate) => {
                                      return {
                                        category: "neutral",
                                        label: plate,
                                      };
                                    })}
                                />
                              ) : null}
                            </PlateSection>
                          </div>
                          <div className="attribute">
                            <div className="titles">{TITLES.segment}</div>
                            <DivColumStatus
                              status={appointment.statusQuote.category}
                            >
                              <div className="type-column-hermes">
                                <b>
                                  {appointment.statusQuote.label.toUpperCase()}
                                </b>
                              </div>
                            </DivColumStatus>
                          </div>
                          <div
                            className="attribute"
                            style={{ paddingLeft: "0.5rem" }}
                          >
                            <div className="titles">{TITLES.turnColumn}</div>
                            <DivColumStatus
                              status={appointment.turn_status.category}
                            >
                              <div className="type-column-hermes">
                                <b>
                                  {appointment.turn_status.label.toUpperCase()}
                                </b>
                              </div>
                            </DivColumStatus>
                          </div>
                          <div className="attribute">
                            <div className="titles">{TITLES.numTurn}</div>
                            <DivFlexColum>
                              <div>
                                {appointment.turnNum
                                  ? appointment.turnNum
                                  : "-"}
                              </div>
                            </DivFlexColum>
                          </div>
                          <div className="attribute">
                            <div className="titles">{TITLES.dockNum}</div>
                            <div>{appointment.dockNum || "-"}</div>
                          </div>
                          <div className="attribute">
                            <div className="titles">{TITLES.actions}</div>
                            <div
                              style={{ display: "flex" }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {appointment.statusTurn ? (
                                <div style={{ fontFamily: "Montserrat" }}>
                                  <div>
                                    {`${
                                      appointment.diffInMinutes === 1
                                        ? "Queda"
                                        : "Quedan"
                                    }`}
                                  </div>

                                  <div
                                    style={{
                                      color: `${
                                        appointment.diffInMinutes >
                                        appointment.redCountDownMinutes
                                          ? "#FEDA46"
                                          : "#FF6F61"
                                      }`,
                                      fontSize: "2.5rem",
                                      fontWeight: 800,
                                    }}
                                  >
                                    {appointment.diffInMinutes}
                                  </div>
                                  <div>
                                    {`${
                                      appointment.diffInMinutes === 1
                                        ? "Minuto"
                                        : "Minutos"
                                    }`}
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <Authorization
                                    actions={[
                                      "appointment.update_appointments",
                                    ]}
                                  >
                                    {invoice.showEditAppointmet && (
                                      <TurnTrackingTableEditButton
                                        appointment={appointment}
                                        loadInvoices={loadInvoices}
                                        setIsLoadingEdit={setIsLoadingEdit}
                                      />
                                    )}
                                  </Authorization>
                                  {!isLoadingEdit && (
                                    <Authorization
                                      actions={[
                                        "appointment.delete_appointments",
                                      ]}
                                    >
                                      {invoice.showDeleteAppointmet && (
                                        <TurnTrackingTableDeleteButton
                                          appointment={appointment}
                                          appointmentId={appointment.id}
                                          loadInvoices={loadInvoices}
                                          setNameDeletedSuccess={
                                            setNameDeletedSuccess
                                          }
                                          setShowModalDeleteAppointment={
                                            setShowModalDeleteAppointment
                                          }
                                          countPageRedirect={(data) => {
                                            setCountNextPage(data);
                                          }}
                                          dateUrlTracking={dateUrlTracking}
                                        />
                                      )}
                                    </Authorization>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </VctTicketRow>
                      );
                    }
                  )}
                </>
              )}
            </>
          )}
        </InvoicesContainer>
        {loadInvoices.status === "SUCCESS" && (
          <>
            {loadInvoices.data.count > 0 && (
              <Container>
                <div className="flex-paginator">
                  <Paginator
                    first={
                      (loadInvoices.params.page - 1) *
                      loadInvoices.data.page_size
                    }
                    rows={loadInvoices.data.page_size}
                    totalRecords={loadInvoices.data.count}
                    onPageChange={(e) => {
                      const targetPage = e.first / loadInvoices.data.page_size;
                      const pathname = history.location.pathname;
                      const parsedParams = parse(history.location.search);
                      const stringifiedParams = stringify({
                        ...parsedParams,
                        page: targetPage + 1,
                      });
                      history.push(`${pathname}?${stringifiedParams}`);
                    }}
                  />
                </div>
              </Container>
            )}
          </>
        )}
        {showSidebar && (
          <VctTicketSidebarTraking
            onOutsideClick={() => {
              toggleSidebar();
            }}
            appointment={dataAppointment}
          />
        )}
      </Authorization>
    </>
  );
};

const TurnTrackingTableDeleteButton = (
  props: ITurnTrackingTableDeleteButton
) => {
  const {
    appointment,
    appointmentId,
    loadInvoices,
    setNameDeletedSuccess,
    setShowModalDeleteAppointment,
    countPageRedirect,
    dateUrlTracking,
  } = props;
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [messageError, updateMessageError] = useState("");
  const [showModalError, updateShowModalError] = useState(false);
  const deleteAppointment = useAsyncExecutor(
    (params: IdeleteAppointmentExecutor) => {
      setNameDeletedSuccess(params.dispatcherName);
      return networkBackendRequest(
        `/appointments/${params.appointmentId}/`,
        HTTP_METHODS.DELETE
      ).then();
    },
    {
      onSuccess: () => {
        getAppoiment.execute({ withdrawal_from_date: dateUrlTracking });
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        updateMessageError(errorMessage);
        updateShowModalError(true);
        setShowModalDelete(false);
      },
    }
  );

  const getAppoiment = useAsyncExecutor2(
    (params: GetAppoimentParams) => {
      return networkBackendRequest(`/appointments/`, HTTP_METHODS.GET, {
        withdrawal_from_date: params.withdrawal_from_date,
      }).then((resp) => resp.json());
    },
    {
      onSuccess: (data) => {
        const count = data.count;
        countPageRedirect(count);
        setShowModalDeleteAppointment(true);
        setShowModalDelete(false);
      },
      onError: () => {
        countPageRedirect(1);
        setShowModalDeleteAppointment(true);
        setShowModalDelete(false);
      },
    }
  );

  return (
    <>
      <DivMarginLeft>
        <Authorization actions={["appointment.delete_appointments"]}>
          <DeleteButton
            tooltipText="Eliminar cita"
            onClick={() => {
              setShowModalDelete(true);
            }}
          />
        </Authorization>
      </DivMarginLeft>
      {showModalDelete && (
        <Modal
          onOutsideClick={() => {
            setShowModalDelete(false);
          }}
        >
          <Container1>
            <h1>Confirmación de eliminación</h1>
            <div className="description">
              <p>
                Se eliminará el VCT, del despachador
                <b style={{ marginLeft: "0.5rem" }}>
                  {appointment.dispatcherName && appointment.dispatcherName}
                </b>
              </p>
            </div>
            <div className="button-container">
              <Button
                status="confirm"
                onClick={() => {
                  deleteAppointment.execute({
                    appointmentId: appointmentId,
                    dispatcherName: appointment.dispatcherName,
                  });
                }}
                disabled={
                  deleteAppointment.isLoading ||
                  getAppoiment.status === "PROCESSING"
                }
              >
                {(deleteAppointment.isLoading || getAppoiment.isLoading) && (
                  <img className="icon" src={LoadingSpinner} alt="spinner" />
                )}
                Eliminar cita
              </Button>
              <Button
                status="cancel"
                onClick={() => {
                  setShowModalDelete(false);
                }}
                disabled={
                  deleteAppointment.isLoading ||
                  getAppoiment.status === "PROCESSING"
                }
              >
                Cancelar
              </Button>
            </div>
          </Container1>
        </Modal>
      )}
      {showModalError && messageError && (
        <ConfirmationModal
          message={messageError}
          onAccept={() => {
            updateMessageError("");
            updateShowModalError(false);
            loadInvoices.retry();
          }}
          title={`Atención`}
          toggleModal={() => {
            updateMessageError("");
            updateShowModalError(false);
            loadInvoices.retry();
          }}
        />
      )}
    </>
  );
};

export function formatTime(time: Date | string) {
  const timeDate = new Date(time);
  return format(timeDate, "HH:mm");
}
const convertTimeslotResponse = (resp: TimesLots) => {
  const details = resp.timeslots.map((detail: Timeslot) => {
    return {
      timeslotId: detail.timeslot_id,
      startDate: detail.start,
      endDate: detail.end,
      label: formatTime(detail.start),
      value: detail.timeslot_id,
    };
  });
  details.sort((a, b) => {
    if (a.label < b.label) {
      return -1;
    } else if (a.label === b.label) {
      return 0;
    } else {
      return 1;
    }
  });
  return details;
};

const convertDispatcherResponse = (resp: CustomDispacher) => {
  const data = resp.customs_dispatchers.map((detail: CustomsDispatcher) => {
    return {
      dispatcherId: detail.dispatcher_id,
      dispatcherName: detail.name,
      label: detail.name,
      value: detail.dispatcher_id,
    };
  });
  return data;
};
const convertVehicleResponse = (resp: VehicleCategory) => {
  const data = {
    maxVehicles: resp.limit_number_vehicles,
    labels: resp.vehicle_category_options.map((vehicleCategory) => {
      return {
        label: vehicleCategory.label,
        value: vehicleCategory.option,
      };
    }),
  };
  return data;
};
const TurnTrackingTableEditButton = (
  props: ITurnTrackingTableEditButtonProps
) => {
  const { appointment, loadInvoices, setIsLoadingEdit } = props;
  const [showEditTicketSidebar, updateShowEditSidebar] =
    useState<boolean>(false);

  const [, setFirstArrived] = useState("");

  const [showModalDataValidVehicleTim, setShowModalDataValidVehicleTim] =
    useState<boolean>();
  const loadScheduleAppointmentTurnTraking = useAsyncExecutor2(
    (params: ParamsLoadSchedule) => {
      const timesLotStart = params.appointment.timeslot.start;
      const { groups_num_gte, withdrawal_date } = params;

      const dispatchers = networkBackendRequest(
        "/customs-dispatchers/",
        HTTP_METHODS.GET
      )
        .then((response) => response.json())
        .then(convertDispatcherResponse);

      const vehicles = networkBackendRequest(
        `/vehicle-category-options/`,
        HTTP_METHODS.GET
      )
        .then((response) => response.json())
        .then(convertVehicleResponse);

      const timeslots = networkBackendRequest("/timeslots/", HTTP_METHODS.GET, {
        groups_num_gte,
        withdrawal_date,
      })
        .then((response) => response.json())
        .then(convertTimeslotResponse);

      return zip(
        dispatchers,
        vehicles,
        timeslots,
        (dispatchers, vehicles, timeslots) => ({
          dispatchers,
          vehicles,
          timeslots,
          timesLotStart,
        })
      ).pipe(
        map((data) => {
          return {
            ...data,
            withdrawalDate: withdrawal_date,
            timesLotStart,
          };
        })
      );
    },
    {
      onSuccess: (data) => {
        const { timeslots } = data;
        const enableDisableModalVehicles = timeslots.length >= 0;
        if (enableDisableModalVehicles) {
          updateShowEditSidebar(true);
        } else {
          setShowModalDataValidVehicleTim(true);
        }
      },
      onError: () => {},
    }
  );

  const isProcessing =
    loadScheduleAppointmentTurnTraking?.status === "PROCESSING";
  useEffect(() => {
    if (isProcessing) {
      setIsLoadingEdit(true);
    } else {
      setIsLoadingEdit(false);
    }
    // eslint-disable-next-line
  }, [isProcessing]);

  return (
    <>
      <>
        {loadScheduleAppointmentTurnTraking.status === "PROCESSING" ? (
          <DivImgLoading>
            <img src={LoadingSpinner} alt="" className="img-size" />
          </DivImgLoading>
        ) : (
          <EditButton
            tooltipText="Editar cita"
            onClick={() => {
              loadScheduleAppointmentTurnTraking.execute({
                groups_num_gte: appointment.groupsNum,
                withdrawal_date: appointment.withdrawalDate,
                appointment,
              });
            }}
          />
        )}
      </>
      {showModalDataValidVehicleTim && (
        <ConfirmationModalThird
          onAccept={() => {
            setFirstArrived("");
            setShowModalDataValidVehicleTim(false);
          }}
          title={"No existen horarios de retiro disponibles"}
          toggleModal={() => {
            setFirstArrived("");
            setShowModalDataValidVehicleTim(false);
          }}
          buttonTitle={"Entendido"}
          backgroundColor={"#002E6C"}
        >
          <p>
            Los Horarios de turnos para la programación de su cita aun no se
            encuentran habilitados en el sistema. Agradeceremos contactarse con
            el equipo de Soporte TalmaClick a los siguientes canales: Email{" "}
            <b> talmaclick@talma.com.pe</b>
          </p>
          <p>
            Cel: <b>981069112 / 936518110</b>{" "}
          </p>
        </ConfirmationModalThird>
      )}

      {showEditTicketSidebar && (
        <VctTicketEditionSidebar
          appointment={appointment}
          onOutsideClick={() => updateShowEditSidebar(false)}
          loadInvoices={loadInvoices}
          timeslots={loadScheduleAppointmentTurnTraking.data.timeslots}
          dispatchers={loadScheduleAppointmentTurnTraking.data.dispatchers}
          vehicleCategories={loadScheduleAppointmentTurnTraking.data.vehicles}
        />
      )}
    </>
  );
};
